// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.date-range-picker {
  /* 選択された日付 */
}
.date-range-picker .date-picker-header {
  display: flex; /* フレックスボックスを使用 */
  justify-content: center; /* 中央揃え */
  align-items: center; /* 縦方向も中央揃え */
  font-size: var(--text-size-normal); /* フォントサイズ */
  margin-bottom: 10px; /* 下のマージン */
}
.date-range-picker .button {
  font-weight: 600;
  font-size: var(--text-size-normal);
  padding: 8px;
  min-height: 32px;
  height: 32px;
}
.date-range-picker .react-datepicker {
  border: none;
  font-family: "Inter";
}
.date-range-picker .react-datepicker__header {
  border: none;
  border-radius: 8px;
}
.date-range-picker .react-datepicker__day--selected,
.date-range-picker .react-datepicker__day--in-selecting-range,
.date-range-picker .react-datepicker__day--in-range,
.date-range-picker .react-datepicker__month-text--selected,
.date-range-picker .react-datepicker__month-text--in-selecting-range,
.date-range-picker .react-datepicker__month-text--in-range,
.date-range-picker .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background: var(--primary-color-main);
  font-weight: normal;
  color: var(--white-color-lightest);
}`, "",{"version":3,"sources":["webpack://./src/components/common/parts/CustomDateRangePicker.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EA0BE,YAAA;AAvBF;AAFE;EACE,aAAA,EAAA,iBAAA;EACA,uBAAA,EAAA,SAAA;EACA,mBAAA,EAAA,aAAA;EACA,kCAAA,EAAA,YAAA;EACA,mBAAA,EAAA,WAAA;AAIJ;AADE;EACE,gBAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAGJ;AAAE;EACI,YAAA;EACA,oBAAA;AAEN;AAAE;EACE,YAAA;EACA,kBAAA;AAEJ;AAEE;;;;;;;EAWE,qCAAA;EACA,mBAAA;EACA,kCAAA;AAJJ","sourcesContent":[".date-range-picker{\r\n  .date-picker-header {\r\n    display: flex; /* フレックスボックスを使用 */\r\n    justify-content: center; /* 中央揃え */\r\n    align-items: center; /* 縦方向も中央揃え */\r\n    font-size: var(--text-size-normal); /* フォントサイズ */\r\n    margin-bottom: 10px; /* 下のマージン */\r\n  }\r\n\r\n  .button{\r\n    font-weight: 600;\r\n    font-size: var(--text-size-normal);\r\n    padding: 8px;\r\n    min-height: 32px;\r\n    height: 32px;\r\n  }\r\n\r\n  .react-datepicker{\r\n      border: none;\r\n      font-family: \"Inter\";\r\n  }\r\n  .react-datepicker__header {\r\n    border: none;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  /* 選択された日付 */\r\n  .react-datepicker__day--selected,\r\n  .react-datepicker__day--in-selecting-range,\r\n  .react-datepicker__day--in-range,\r\n  .react-datepicker__month-text--selected,\r\n  .react-datepicker__month-text--in-selecting-range,\r\n  .react-datepicker__month-text--in-range,\r\n  .react-datepicker__time-container\r\n    .react-datepicker__time\r\n    .react-datepicker__time-box\r\n    ul.react-datepicker__time-list\r\n    li.react-datepicker__time-list-item--selected {\r\n    background: var(--primary-color-main);\r\n    font-weight: normal;\r\n    color: var(--white-color-lightest);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
